import { createYupSync } from "@lib/helpers/TableHelper";
import { walletAddressSchema as yupSchema } from "@lib/schemas/wallet";
import { WalletAddressCreationType } from "@lib/types/Billing";
import { SendByteWalletAddressCreationType } from "@lib/types/SendByte";
import { Form, Radio } from "antd";
import { FormInstance } from "antd/lib";
import { useIntl } from "react-intl";

type CreationType =
  | WalletAddressCreationType
  | SendByteWalletAddressCreationType;

type Props = {
  show: boolean;
  creationType: CreationType;
  setCreationType: (value: CreationType) => void;
  form: FormInstance<any>;
  loading: boolean;
};

export default function WalletAddressCreationTypeInput(props: Props) {
  const { show, setCreationType, loading, form } = props;
  const { messages } = useIntl();
  const walletId = Form.useWatch("walletId", form);

  if (!show) {
    return null;
  }

  return (
    <Form.Item
      name="creationType"
      rules={[createYupSync({ schema: yupSchema })]}
      label={messages["common.creationType"] as string}
    >
      <Radio.Group
        disabled={loading || !walletId}
        onChange={(e) => setCreationType(e.target.value)}
      >
        <Radio.Button value={WalletAddressCreationType.SINGLE} checked={true}>
          {messages["common.single"] as string}
        </Radio.Button>
        <Radio.Button value={WalletAddressCreationType.MULTIPLE}>
          {messages["common.multiple"] as string}
        </Radio.Button>
      </Radio.Group>
    </Form.Item>
  );
}
